import React from 'react'
import { Link } from 'react-router-dom';
function FooterOne() {
    return (
        <div>

            {/* rts footer area start */}
            <div className="rts-footer-area footer-one rts-section-gapTop bg-footer-one" id='f-contact'>
                <div className="container bg-shape-f1">
                    {/* footer call to action area */}
                    <div className="row">
                        <div className="col-12">
                            <div className="rts-cta-wrapper">
                                <div className="background-cta">
                                    <div className="row">
                                        {/* cta-left */}
                                        <div className="col-lg-6">
                                            <div className="cta-left-wrapepr">
                                                <p className="cta-disc">Restez informé</p>
                                                <h3 className="title">Inscrivez-vous à notre newsletter</h3>
                                            </div>
                                        </div>
                                        {/* cta left end */}
                                        <div className="col-lg-6">
                                            {/* cta right */}
                                            <form className="cta-input-arae">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Entrez votre adresse email"
                                                    required=""
                                                />
                                                <button type="submit" className="rts-btn btn-primary">
                                                    S'abonner
                                                </button>
                                            </form>
                                            {/* cta right End */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* footer call to action area End */}
                    {/* rts footer area */}
                    <div className="row pt--120 pt_sm--80 pb--80 pb_sm--40">
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12">
                            <div className="footer-one-single-wized">
                                <div className="wized-title">
                                    <h5 className="title">Liens rapides</h5>
                                    <img
                                        src="/assets/images/footer/under-title.png"
                                        alt="finbiz_footer"
                                    />
                                </div>
                                <div className="quick-link-inner">
                                    <ul className="links">
                                        <li>
                                            <Link to={'/'}>
                                                <i className="far fa-arrow-right" /> Accueil
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={'/qui-sommes-nous'}>
                                                <i className="far fa-arrow-right" /> Qui sommes-nous
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={'/our-service'}>
                                                <i className="far fa-arrow-right" /> Services
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={'/contactus'}>
                                                <i className="far fa-arrow-right" /> Contact
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* footer mid area */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12">
                            <div className="footer-one-single-wized mid-bg">
                                <div className="wized-title">
                                    <h5 className="title">Horaires d'ouverture</h5>
                                    <img
                                        src="/assets/images/footer/under-title.png"
                                        alt="finbiz_footer"
                                    />
                                </div>
                                <div className="opening-time-inner">
                                    <div className="single-opening">
                                        <p className="day">Lundi - Vendredi</p>
                                        <p className="time">8h00 - 12h00 / 13h00 - 17h00</p>
                                    </div>
                                    <div className="single-opening">
                                        <p className="day">Sur rendez-vous</p>
                                        <p className="time">En dehors des heures</p>
                                    </div>
                                    <div className="single-opening mb--30 mb_sm--10">
                                        <p className="day">Service d'astreinte</p>
                                        <p className="time">24h/24 pour les clients</p>
                                    </div>
                                    <Link to={'/contactus'} className="rts-btn btn-primary contact-us">
                                        Nous contacter
                                    </Link>
                                </div>
                            </div>
                        </div>
                        {/* footer mid area end */}
                        {/* footer end area post */}
                        <div className="col-xl-4 col-md-6 col-sm-12 col-12">
                            <div className="footer-one-single-wized margin-left-65">
                                <div className="wized-title">
                                    <h5 className="title">Coordonnées</h5>
                                    <img
                                        src="/assets/images/footer/under-title.png"
                                        alt="finbiz_footer"
                                    />
                                </div>
                                <div className="post-wrapper">
                                    <div className="single-footer-post mb--30">
                                        <div className="post-right">
                                            <p style={{ color: '#fff' }}>
                                                <i className="fas fa-map-marker-alt" /> Adresse
                                            </p>
                                            <h6 className="title" style={{ fontSize: '14px', lineHeight: '1.6', color: '#fff' }}>
                                                Entrée Port de Pointe-Noire, en diagonale de la Banque Postale du Port, Pointe-Noire – République du Congo
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="single-footer-post mb--30">
                                        <div className="post-right">
                                            <p style={{ color: '#fff' }}>
                                                <i className="fas fa-phone" /> Téléphones
                                            </p>
                                            <h6 className="title" style={{ color: '#fff' }}>
                                                <Link to={'tel:+242067972870'} style={{ color: '#fff' }}>06 797 28 70</Link> / <Link to={'tel:+242050400771'} style={{ color: '#fff' }}>05 040 07 71</Link>
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="single-footer-post">
                                        <div className="post-right">
                                            <p style={{ color: '#fff' }}>
                                                <i className="fas fa-envelope" /> Email
                                            </p>
                                            <h6 className="title" style={{ color: '#fff' }}>
                                                <Link to={'mailto:contact@global-servicescg.com'} style={{ color: '#fff' }}>contact@global-servicescg.com</Link>
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* footer end area post end*/}
                    </div>
                    {/* rts footer area End */}
                </div>
                {/* copyright area start */}
                <div className="rts-copyright-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="text-center">
                                    <p>Développé par <a href="https://www.jibuness.com" target="_blank" rel="noopener noreferrer" style={{ color: '#df0a0a', textDecoration: 'underline' }}>Jibuness</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* copyright area end */}
            </div>
            {/* rts footer area end */}

        </div>
    )
}

export default FooterOne